import React from 'react';
import {Breadcrumb, Button} from "antd";

const BreadcrumbAntd = ({ breadcrumbs, showEndingSeparator }) => {
    // WIP. Currently only works with manual onClick to set location functions. e.g. () =>
    // Doesn't work with just links by themselves.
    // Note on usage.
    // A breadcrumb should be used on a page where there are no tabs. Adding it to a page with tabs will cause user confusion.
    // The form of the breadcrumb should be 'highest level page' > then the breadcrumb content
    // Use showEndingSeparator where you want to have the > and then you are putting a <h2> or something directly after
    // else just put the final page and ignore showEndingSeparator (e.g. Reports > Student Reports > Timmy McGee)

    const breadcrumbItems = [
        ...breadcrumbs.map(breadcrumb => ({
            title: (
                <Button
                    type="link"
                    className="ch-breadcrumb-button"
                    onClick={breadcrumb.function}
                    style={{ cursor: 'pointer' }}
                >
                    {breadcrumb.label}
                </Button>
            )
        })),
        ...(showEndingSeparator ? [{ title: <></> }] : [])
    ];

    return (
        <Breadcrumb
            items={breadcrumbItems}
            separator={'>'}
        />
    );
};

export default BreadcrumbAntd;